import { Box } from "@mui/material";
import CustomCard from "./../../CustomCard/index";
import { useNavigate } from "react-router";

const NotificationCardWrapper = ({
  firstChild,
  seccondChild,
  ThirdChild,
  firstButton,
  seccondButton,
  styling,
  link,
}) => {
  const navigate = useNavigate();

  return (
    <CustomCard pSize={12} radius={16} mBottom={16} mTop={16} minHeight={82}>
      <Box
        onClick={link ? () => navigate(link) : null}
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "8px",
          alignItems: "center",
          ...styling,
        }}
      >
        {firstChild ? firstChild : <span></span>}
        {seccondChild ? seccondChild : <span></span>}
        {ThirdChild ? ThirdChild : <span></span>}
      </Box>
      {(firstButton || seccondButton) && (
        <Box
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "16px",
            marginTop: "16px",
          }}
        >
          {firstButton && firstButton}
          {seccondButton && seccondButton}
        </Box>
      )}
    </CustomCard>
  );
};

export default NotificationCardWrapper;
